import { render, staticRenderFns } from "./CreateOrderShipmentPopUp.vue?vue&type=template&id=f76277fc&scoped=true&"
import script from "./CreateOrderShipmentPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateOrderShipmentPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderShipmentPopUp.vue?vue&type=style&index=0&id=f76277fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76277fc",
  null
  
)

export default component.exports